// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	// Child Issue Limit Panel Title
	oldChildIssuesLimitTitle: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.child-issues-limit-title-with-header-icons',
		defaultMessage: 'View child issues in search',
		description: 'title for children limit panel',
	},
	childIssuesLimitTitle: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.child-issues-limit-title',
		defaultMessage: 'View child issues using search',
		description: 'title for children limit panel',
	},
	oldChildIssuesLimitTitleIssueTermRefresh: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.child-issues-limit-title-issue-term-refresh-with-header-icons',
		defaultMessage: 'View child work items in search',
		description: 'title for children limit panel',
	},
	childIssuesLimitTitleIssueTermRefresh: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.child-issues-limit-title-issue-term-refresh',
		defaultMessage: 'View child work items using search',
		description: 'title for children limit panel',
	},
	// Description with Time Tracking
	oldWithTimetrackingChildIssuesLimitDescription: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.with-timetracking-child-issues-limit-description-with-limit-with-header-icons',
		defaultMessage:
			"The issue view can only display up to {limit} child issues. You can still add and bulk edit them from here, but you'll have to view them in search and won't be able to include them in time tracking. {learnMoreLink}",
		description: 'description for children limit panel on issues with timetracking included',
	},
	withTimetrackingChildIssuesLimitDescription: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.with-timetracking-child-issues-limit-description-with-limit',
		defaultMessage:
			'Issues only display up to {limit} {learnMoreLink}. You can see them all using View in search (they won’t be included in time tracking).',
		description: 'description for children limit panel on issues with timetracking included',
	},
	oldWithTimetrackingChildIssuesLimitDescriptionIssueTermRefresh: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.with-timetracking-child-issues-limit-description-with-limit-issue-term-refresh-with-header-icons',
		defaultMessage:
			"The work item can only display up to {limit} child work items. You can still add and bulk edit them from here, but you'll have to view them in search and won't be able to include them in time tracking. {learnMoreLink}",
		description: 'description for children limit panel on issues with timetracking included',
	},
	withTimetrackingChildIssuesLimitDescriptionIssueTermRefresh: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.with-timetracking-child-issues-limit-description-with-limit-issue-term-refresh',
		defaultMessage:
			'Work items only display up to {limit} {learnMoreLink}. You can see them all using View in search (they won’t be included in time tracking).',
		description: 'description for children limit panel on issues with timetracking included',
	},
	// Description without Time Tracking
	oldWithoutTimetrackingChildIssuesLimitDescription: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.without-timetracking-child-issues-limit-description-with-limit-with-header-icons',
		defaultMessage:
			"The issue view can only display up to {limit} child issues. You can still add and bulk edit them from here, but you'll have to view them in search. {learnMoreLink}",
		description: 'description for children limit panel on issues without timetracking included',
	},
	withoutTimetrackingChildIssuesLimitDescription: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.without-timetracking-child-issues-limit-description-with-limit',
		defaultMessage:
			'Issues only display up to {limit} {learnMoreLink}. You can see them all using View in search.',
		description: 'description for children limit panel on issues without timetracking included',
	},
	oldWithoutTimetrackingChildIssuesLimitDescriptionIssueTermRefresh: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.without-timetracking-child-issues-limit-description-with-limit-issue-term-refresh-with-header-icons',
		defaultMessage:
			"The work item can only display up to {limit} child work item. You can still add and bulk edit them from here, but you'll have to view them in search. {learnMoreLink}",
		description: 'description for children limit panel on issues without timetracking included',
	},
	withoutTimetrackingChildIssuesLimitDescriptionIssueTermRefresh: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.without-timetracking-child-issues-limit-description-with-limit-issue-term-refresh',
		defaultMessage:
			'Work items only display up to {limit} {learnMoreLink}. You can see them all using View in search.',
		description: 'description for children limit panel on issues without timetracking included',
	},
	// Learn more about child issues link
	oldLearnMoreAboutChildIssuesLink: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.learn-more-about-child-issues-link-with-header-icons',
		defaultMessage: 'Learn more about child issues',
		description: 'Text for the link to the learn more in-product child issues help',
	},
	learnMoreAboutChildIssuesLink: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.learn-more-about-child-issues-link',
		defaultMessage: 'child issues',
		description: 'Text for the link to the learn more in-product child issues help',
	},
	oldLearnMoreAboutChildIssuesLinkIssueTermRefresh: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.learn-more-about-child-issues-link-issue-term-refresh-with-header-icons',
		defaultMessage: 'Find out more about child work items',
		description: 'Text for the link to the learn more in-product child issues help',
	},
	learnMoreAboutChildIssuesLinkIssueTermRefresh: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.learn-more-about-child-issues-link-issue-term-refresh',
		defaultMessage: 'child work items',
		description: 'Text for the link to the learn more in-product child issues help',
	},
});
